/**
 * 修改资料
 * 2017-12-6
 */
"use strict";
angular.module("modifyDataModule", ["zoneServiceModule"]).
controller("modifyDataCtrl", ["$scope", "$timeout", "$q", "$state", "editPictureService", "zoneService", "httpService", "modalDialog", "Upload", '$validation', "$element", function($scope, $timeout, $q, $state, editPictureService, zoneService, httpService, modalDialog, Upload, $validation, $element) {
    initStatus();
    initData();

    function initStatus() {
        $scope.headPic = '';
        $scope.status = {};
        $scope.info = {};
        $scope.listData = "";
        $scope.hasName = false;
    }

    function initData() {
        requestData();
        getPicSizeLimit();
    }

    /**
     * [changeNumber description] 更换号码
     * @return {[type]} [description]
     */
    $scope.changeNumber = function() {
        zoneService.changeNumber($scope.status).then(function(data) {
            requestData();
        });
    };

    /**
     * [uploadHeader description] 换头像
     * @return {[type]} [description]
     */
    $scope.uploadHeader = function() {
        zoneService.uploadHeader($scope.status).then(function(data) {})
    };
    /**
     * [save description] 保存修改
     * @return {[type]} [description]
     */
    $scope.save = function() {
        $validation.validate($scope.changePwdForm).success(function(data) {
            var params = {
                truename: $scope.info.truename,
                sex: $scope.status.sex,
                email: $scope.info.email,
                unit: $scope.info.unit,
                address: $scope.info.address,
                logo: $scope.logo,
            };

            modalDialog.confirmModal('保存', '是否保存修改的内容？', function() {
                sendtoService();
            });

            function sendtoService() {
                httpService.http("/mcnww/web/ucenter/ugcUpdateInfo.do", params, "post").then(function(result) {
                    modalDialog.success("内容修改成功", "success", false, function() {}, function() {}, '');
                    $state.go($state.current.name, "", { reload: $state.current.name });
                    $scope.$root.$broadcast("sucessLogo", true);
                });
            }
        }).error(function(info) {
            angular.invalidPosition($scope.changePwdForm, $element);
        })

    };
    /**
     * [choseSex description]性别
     */
    $scope.choseSex = function(value) {
        $scope.status.sex = value;
    };

    /**
     * [requestData description] 产品列表查询
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        requestData();
    };
    /**
     * [requestData description] 初始化列表数据
     */
    function requestData() {
        $scope.loadingPromise = httpService.http("/mcnww/web/user/getLoginUser.do", "", "get").then(function(data) {
            $scope.info = data.loginUser;
            $scope.status.sex = data.loginUser.sex;
            if (data.loginUser.logo != null) {
                $scope.headPic = angular.globalConfig.pictureServer + data.loginUser.logo;
            } else {
                $scope.headPic = './images/uperroe.png';
            }

            if (data.loginUser.truename == "" || data.loginUser.truename == null) {
                $scope.hasName = true;
            } else {
                $scope.hasName = false;
            }
        });
    };
    /**
     * [changeHeadPortrait description]  更换头像
     * @param  {[type]} files    [description]
     * @param  {[type]} file     [description]
     * @param  {[type]} newFiles [description]
     * @return {[type]}          [description]
     */
    $scope.changeHeadPortrait = function(files, file, newFiles) {
        //不能是gif
        var typeData = file.type.split('/')[1];
        if (typeData != 'jpg' && typeData != 'jpeg' && typeData != 'png') {
            modalDialog.success("您只能上传jpg,jpeg,png类型的文件", "success", false, function() {}, function() {}, '', 'notice');
            return;
        }
        if (!file) return;
        if (file.size > Number($scope.status.picSizeLimit) * 1024) {
            modalDialog.alertType("", "图片最大不能超过" + $scope.status.picSizeLimit + "KB!", "warning", "confirm");
            return;
        }
        if (newFiles) {
            $scope.status.changeHeader = true;
        }
        $scope.loadingPromise = uploadPic(newFiles).then(function(resp) {
            editPictureService.newCropperApp(angular.globalConfig.pictureServer + resp.data.url, "100,100").then(function(data) {
                var time = new Date().getTime();
                $scope.headPic = data.imgSrc + '?' + time;
                $scope.logo = data.imgSrc;
            }, function(res) {

            });
        });
    };
    /**
     * [uploadPic description] 上传图片
     * @return {[type]} [description]
     */
    function uploadPic(newFiles) {
        var deffer = $q.defer();
        Upload.upload({
            url: "/mcnww/upload/userLogo.do",
            headers:{requestToken:sessionStorage.getItem('requestToken')},
            data: {
                file: newFiles[0]
            },
        }).then(function(resp) {
            if (!resp.data.success) {
                modalDialog.success(resp.data.message, "success", false, function() {});
                deffer.reject(resp);
                return;
            }
            deffer.resolve(resp);
        });
        return deffer.promise;
    }
    /**
     * [getPicSizeLimit description] 获取图片尺寸上限
     * @return {[type]} [description]
     */
    function getPicSizeLimit() {
        httpService.http("/mcnww/web/image/getImageSizelimit.do", "", "get").then(function(data) {
            $scope.status.picSizeLimit = data.message;
        });
    }

    $scope.singleValidate = function() {
        $validation.validate();
    };
}]);